import { useFetchItems } from 'pe-core-frontend';
import { REPORT_TEMPLATES } from '../graphql/queries/reportTemplate';
/**
 * Custom hook for fetching and managing imports.
 *
 * @param {UseReportsProps} options - The options for the hook.
 * @param {string} options.clientId - The client ID.
 * @returns {Object} - The import items, error, and loading state.
 */
export const useReports = ({ clientId, id, showInDashboard, isActive }) => {
    const { items, error, loading, refetch, find } = useFetchItems({
        fetchQuery: REPORT_TEMPLATES,
        dataProp: 'reportTemplates',
        spec: { clientId, id, showInDashboard, isActive },
    });
    return {
        items,
        error,
        loading,
        refetch,
        find,
    };
};
